module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-classic-800.7fb48daa.svg";